import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a92dcd4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-logo" }
const _hoisted_2 = { class: "icon-wrapper" }
const _hoisted_3 = {
  key: 1,
  class: "profile-mini"
}
const _hoisted_4 = { class: "name item" }
const _hoisted_5 = { class: "name-icon" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/account/info",
  class: "app-text__a"
}, "Профиль", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/order-sheet",
  class: "app-text__a"
}, "Страница заказов", -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_text = _resolveComponent("app-text")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    class: "profile-block",
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleProfile && _ctx.toggleProfile(...args)))
  }, [
    (_ctx.$isWindow.desktop)
      ? (_openBlock(), _createBlock(_component_app_text, {
          key: 0,
          text: _ctx.name
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_app_icon, {
          name: "icon-profile",
          size: "16"
        })
      ])
    ]),
    (_ctx.isShow)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_app_text, {
              text: _ctx.getName,
              tag: "p"
            }, null, 8, ["text"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_app_icon, {
                name: "icon-profile",
                size: "16"
              })
            ])
          ]),
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToProfile && _ctx.goToProfile(...args)))
          }, _hoisted_7),
          (this.IS_VERIFIED)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "item",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToOrderSheet && _ctx.goToOrderSheet(...args)))
              }, _hoisted_9))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, [
            _createVNode(_component_app_text, {
              text: "Выйти",
              tag: "p"
            })
          ])
        ])), [
          [_directive_click_outside, _ctx.clickOutside]
        ])
      : _createCommentVNode("", true)
  ]))
}